import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Typography from '@material-ui/core/Typography';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { Grid, units } from '@ha/dsl';
import { useLocation } from 'ha/helpers/router';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      [theme.breakpoints.up('md')]: {
        marginBottom: units.rem(1),
      },
      [theme.breakpoints.down('sm')]: {
        margin: units.trbl(0.5, 0, 0.7, 0),
      },
    },
    grid: {
      border: units.border(1, 'solid', theme.palette.primary.main),
      borderRadius: units.rem(0.4),
      padding: units.rem(0.5),
    },
    icon: {
      width: units.rem(2),
      height: units.rem(2),
    },
    text: {
      marginLeft: units.rem(0.5),
    },
  }),
);

const Notification: React.FC = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.wrapper}>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        wrap="nowrap"
        className={styles.grid}
      >
        <CalendarToday color="primary" className={styles.icon} />
        <Typography variant="subtitle1" color="primary" className={styles.text}>
          {children}
        </Typography>
      </Grid>
    </div>
  );
};

export const SearchResultsNotification: React.FC = () => {
  const { T } = useIntl();
  const { lg } = useMediaQuery();
  const {
    query: { startDate, endDate },
  } = useLocation();

  if (!startDate) {
    return null;
  }

  const noBookingFeeTargetDate = new Date(2020, 8, 30, 24, 0, 0, 0).getTime();
  const startingDate = new Date(startDate);

  startingDate.setHours(0, 0, 0, 1);
  const startDateMs = startingDate.getTime();

  if (startDateMs <= noBookingFeeTargetDate) {
    return (
      <Notification>
        {T(
          'For all bookings with a move-in date between 15.04.20 and 30.06.20, no booking fee applies.',
        )}
      </Notification>
    );
  }

  const areBothDatesSet = startDate && endDate;

  if (areBothDatesSet) {
    return (
      <Notification>
        {!lg && `${T('Hurry up!')} `}
        {T(
          'Most of our listings have already been rented out for these dates.',
        )}
      </Notification>
    );
  }

  return null;
};
